import type { ButtonHTMLAttributes } from 'react';
import styles from './FilterChip.module.css';

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'aria-pressed'> {
  selected: boolean;
}

/** Filter chip; the selected chip is filled --ink (DESIGN_SYSTEM §4, Library). */
export function FilterChip({ selected, className, type = 'button', ...rest }: Props) {
  return <button type={type} className={[styles.chip, className].filter(Boolean).join(' ')} aria-pressed={selected} {...rest} />;
}
